import { IonItem, IonToggle } from '@ionic/react';
import { usePreferences } from '@trycourier/react-hooks';
import {
  ChannelClassification,
  IPreferenceTemplate,
  PreferenceStatus,
} from '@trycourier/react-hooks/typings/preferences/types';
import React from 'react';

interface NotificationTopicToggleProps {
  topic: IPreferenceTemplate;
  routingPreferences: ChannelClassification[];
  defaultRoutingOptions: ChannelClassification[];
  defaultHasCustomRouting: boolean;
  hasCustomRouting: boolean;
  status?: PreferenceStatus;
  onChange: (status: PreferenceStatus) => Promise<void>;
  isAdmin: boolean;
}

const getStatusString = (status: boolean) => {
  return status ? 'Opted In' : 'Opted Out';
};

const HELPER_TEXT = {
  ['Case Notifications']: 'Get notified when a case report is ready',
  ['New Messages']: 'Get notified when pathologists send you a message',
  // ['Report Ready']:
  //   'Get notified when a case is signed off and your report is ready',
};
const ADMIN_HELPER_TEXT = {
  ['Case Notifications']: 'Get notified when a new case is submitted',
  ['New Messages']: 'Get notified when you receive a case message',
};

const NotificationTopicToggle: React.FC<NotificationTopicToggleProps> = ({
  topic,
  routingPreferences,
  defaultHasCustomRouting,
  defaultRoutingOptions,
  hasCustomRouting,
  status,
  onChange,
  isAdmin,
}) => {
  // If there user hasn't set a status then use the default status to set the toggle.
  const [statusToggle, setStatusToggle] = React.useState(
    status ? status === 'OPTED_IN' : topic.defaultStatus !== 'OPTED_OUT'
  );
  // TODO uncomment when we can save this in Courier
  // const [routing, setRouting] = React.useState(routingPreferences);
  // const { preferencePage, updateRecipientPreferences } = usePreferences();

  // const customChannelNames = React.useMemo(() => {
  //   if (!preferencePage?.channelConfigs?.channelLabels) {
  //     return {};
  //   }
  //   return preferencePage?.channelConfigs?.channelLabels?.reduce(
  //     (acc, channel) => {
  //       acc[channel.channel] = channel.name;
  //       return acc;
  //     },
  //     {} as Record<ChannelClassification, string>
  //   );
  // }, [preferencePage?.channelConfigs?.channelLabels]);

  const disabled = topic.defaultStatus === 'REQUIRED';
  const helperText = isAdmin ? ADMIN_HELPER_TEXT : HELPER_TEXT;

  return (
    <IonItem>
      <IonToggle
        checked={statusToggle}
        disabled={disabled}
        onIonChange={(e) => {
          if (disabled) {
            return;
          }
          onChange(e.detail.checked ? 'OPTED_IN' : 'OPTED_OUT');
          setStatusToggle(e.detail.checked);
        }}
        title={disabled ? 'Required' : getStatusString(statusToggle)}
        helperText={disabled ? 'Required' : helperText[topic.templateName]}
      >
        {topic.templateName}
      </IonToggle>
    </IonItem>
  );
};

export default NotificationTopicToggle;
